import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Styled discount bubble component
const DiscountBubble = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '10px',
  left: '10px',
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  borderRadius: '50%',
  width: '52px',
  height: '52px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px',
  zIndex: 10,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  transform: 'rotate(-5deg)',
  animation: 'pulse 2s infinite',
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(220, 0, 0, 0.4)'
    },
    '70%': {
      boxShadow: '0 0 0 6px rgba(220, 0, 0, 0)'
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(220, 0, 0, 0)'
    }
  }
}));

// Calculate max discount percentage from dateRangeWithPrices
const calculateMaxDiscount = (dateRangeWithPrices) => {
  if (!dateRangeWithPrices || dateRangeWithPrices.length === 0) {
    return 0;
  }

  let maxDiscountPercentage = 0;

  dateRangeWithPrices.forEach(day => {
    if (day.original_price !== '-' && day.price !== '-') {
      const originalPrice = parseFloat(day.original_price);
      const currentPrice = parseFloat(day.price);
      
      if (originalPrice > 0 && currentPrice < originalPrice) {
        const discountPercentage = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
        maxDiscountPercentage = Math.max(maxDiscountPercentage, discountPercentage);
      }
    }
  });

  return maxDiscountPercentage;
};

const WeeklyDiscountBubble = ({ dateRangeWithPrices, minDiscountThreshold = 5 }) => {
  const maxDiscount = calculateMaxDiscount(dateRangeWithPrices);
  
  // Only show if discount is above threshold
  if (maxDiscount <= minDiscountThreshold) {
    return null;
  }

  return (
    <DiscountBubble>
      <Typography variant="caption" sx={{ fontSize: '0.6rem', lineHeight: 1, fontWeight: 500 }}>
        UP TO
      </Typography>
      <Typography variant="h6" sx={{ fontSize: '1.2rem', lineHeight: 1, fontWeight: 700 }}>
        {maxDiscount}%
      </Typography>
      <Typography variant="caption" sx={{ fontSize: '0.6rem', lineHeight: 1, fontWeight: 500 }}>
        OFF
      </Typography>
    </DiscountBubble>
  );
};

export default WeeklyDiscountBubble;